export function getInviteCode() {
    return new URLSearchParams(window.location.search).get("inviteCode");
}
